import { InputProps } from 'antd';

import { formattedNumber } from '@lib/utils/stringHelper';

import { CustomInputProps } from './customInputProps.type';
import { Input } from './Input';

type Props = InputProps & CustomInputProps;

export const PhoneInput = ({ value, ...otherProps }: Props): JSX.Element => {
  return <Input {...otherProps} value={formattedNumber(value)} type='tel' />;
};
